import { render, staticRenderFns } from "./8RankManagement.vue?vue&type=template&id=205a2ac8&scoped=true&"
import script from "./8RankManagement.vue?vue&type=script&lang=js&"
export * from "./8RankManagement.vue?vue&type=script&lang=js&"
import style0 from "./8RankManagement.vue?vue&type=style&index=0&id=205a2ac8&scoped=true&lang=css&"
import style1 from "./8RankManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a2ac8",
  null
  
)

export default component.exports